<template>
    <div class="global-login">
        <div class="global-login__body">
            <slot v-html="bodyText" />
        </div>
        <div class="button-wrapper v-center left spaced spacer--top">
            <template v-for="button in buttons">
                <a class="button button--primary" :href="button.link" v-html="button.label"></a>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "global-login",
    data: function () {
        return {
            buttons: [],
            bodyText: ''
        }
    },
    mounted() {
        this.buttons.push({
            link: window.PFL_AUTH_URI_LOGIN,
            label: window.pimLocalization.login.loginLabel
        });
        this.buttons.push({
            link: window.PFL_AUTH_URI_REGISTER,
            label: window.pimLocalization.login.registerLabel
        });
        this.bodyText = window.pimLocalization.login.body
    }
}
</script>
